module.exports = __webpack_public_path__ + "img/9788932905907.16fa503e.jpg";